import { CHANGELOG } from './changelog.js';
/**
 * Application version (SemVer) — DÉRIVÉE du changelog, qui est la source de vérité.
 *
 * Elle était une constante isolée que rien n'obligeait à toucher : elle est restée à 1.0.0 pendant
 * tout le mois d'août alors que sept lots ont été déployés. En la lisant depuis l'entrée la plus
 * récente du changelog, publier une version DEVIENT écrire ce qu'elle contient — les deux ne peuvent
 * plus diverger.
 *
 * Affichée dans la barre latérale et renvoyée par /health. Les `version` des package.json suivent
 * cette valeur ; la release est taguée `v<version>`.
 */
export const APP_VERSION = CHANGELOG[0].version;
//# sourceMappingURL=version.js.map